export const emailRegExp = /^[_A-Za-z0-9\-+]+(\.[_A-Za-z0-9]+)*@[A-Za-z0-9]+([_.][A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
export const creditCardRegx = /^[0-9]{0,16}$/;
export const dualCardRegex = /(^546680.{6}|^(78|79).{10}).*$/;
export const jcpMasterRegex = /(^546680.{6}|^(78|79).{10}).*$/;
export const jcpRegex = /^\d{11}$|^\d{16}$/;
